 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLEBB from '@/components/xhtml/EBB'
 import XHTMLLOVE1 from '@/components/xhtml/love1'
 import XHTML01_TITLE from '@/components/xhtml/01_Title'
 import XHTML02_DADICATION from '@/components/xhtml/02_Dadication'
 import XHTML03_FM01 from '@/components/xhtml/03_Fm01'
 import XHTML04_FM02 from '@/components/xhtml/04_Fm02'
 import XHTMLTOC from '@/components/xhtml/Toc'
 import XHTML06_REVISED_EDITION from '@/components/xhtml/06_Revised_edition'
 import XHTML07_PREFACE from '@/components/xhtml/07_Preface'
 import XHTML09_CHRONOLOGY from '@/components/xhtml/09_Chronology'
 import XHTML10_PART1 from '@/components/xhtml/10_Part1'
 import XHTML11_PART2 from '@/components/xhtml/11_Part2'
 import XHTML12_CHAPTER1 from '@/components/xhtml/12_Chapter1'
 import XHTML13_CHAPTER2 from '@/components/xhtml/13_Chapter2'
 import XHTML14_CHAPTER3 from '@/components/xhtml/14_Chapter3'
 import XHTML15_PART3 from '@/components/xhtml/15_Part3'
 import XHTML16_CHAPTER4 from '@/components/xhtml/16_Chapter4'
 import XHTML17_CHAPTER5 from '@/components/xhtml/17_Chapter5'
 import XHTML18_CHAPTER6 from '@/components/xhtml/18_Chapter6'
 import XHTML19_CHAPTER7 from '@/components/xhtml/19_Chapter7'
 import XHTML20_PART4 from '@/components/xhtml/20_Part4'
 import XHTML21_CHAPTER8 from '@/components/xhtml/21_Chapter8'
 import XHTML22_CHAPTER9 from '@/components/xhtml/22_Chapter9'
 import XHTML23_CHAPTER10 from '@/components/xhtml/23_Chapter10'
 import XHTML24_CHAPTER11 from '@/components/xhtml/24_Chapter11'
 import XHTML25_CHAPTER12 from '@/components/xhtml/25_Chapter12'
 import XHTML26_CHAPTER13 from '@/components/xhtml/26_Chapter13'
 import XHTML27_PART5 from '@/components/xhtml/27_Part5'
 import XHTML28_CHAPTER14 from '@/components/xhtml/28_Chapter14'
 import XHTML29_CHAPTER15 from '@/components/xhtml/29_Chapter15'
 import XHTML30_CHAPTER16 from '@/components/xhtml/30_Chapter16'
 import XHTML31_CHAPTER17 from '@/components/xhtml/31_Chapter17'
 import XHTML32_CHAPTER18 from '@/components/xhtml/32_Chapter18'
 import XHTML33_CHAPTER19 from '@/components/xhtml/33_Chapter19'
 import XHTML34_CHAPTER20 from '@/components/xhtml/34_Chapter20'
 import XHTML35_CHAPTER21 from '@/components/xhtml/35_Chapter21'
 import XHTML36_CHAPTER22 from '@/components/xhtml/36_Chapter22'
 import XHTML37_CHAPTER23 from '@/components/xhtml/37_Chapter23'
 import XHTML38_CHAPTER24 from '@/components/xhtml/38_Chapter24'
 import XHTML39_CHAPTER25 from '@/components/xhtml/39_Chapter25'
 import XHTML40_CHAPTER26 from '@/components/xhtml/40_Chapter26'
 import XHTML41_CHAPTER27 from '@/components/xhtml/41_Chapter27'
 import XHTML42_CHAPTER28 from '@/components/xhtml/42_Chapter28'
 import XHTML43_PART6 from '@/components/xhtml/43_Part6'
 import XHTML44_CHAPTER29 from '@/components/xhtml/44_Chapter29'
 import XHTML45_CHAPTER30 from '@/components/xhtml/45_Chapter30'
 import XHTML46_CHAPTER31 from '@/components/xhtml/46_Chapter31'
 import XHTML47_CHAPTER32 from '@/components/xhtml/47_Chapter32'
 import XHTML48_CHAPTER33 from '@/components/xhtml/48_Chapter33'
 import XHTML49_CHAPTER34 from '@/components/xhtml/49_Chapter34'
 import XHTML50_CHAPTER35 from '@/components/xhtml/50_Chapter35'
 import XHTML51_CHAPTER36 from '@/components/xhtml/51_Chapter36'
 import XHTML52_CHAPTER37 from '@/components/xhtml/52_Chapter37'
 import XHTML53_CHAPTER38 from '@/components/xhtml/53_Chapter38'
 import XHTML54_CHAPTER39 from '@/components/xhtml/54_Chapter39'
 import XHTML55_PART7 from '@/components/xhtml/55_Part7'
 import XHTML56_CHAPTER40 from '@/components/xhtml/56_Chapter40'
 import XHTML57_CHAPTER41 from '@/components/xhtml/57_Chapter41'
 import XHTML58_CHAPTER42 from '@/components/xhtml/58_Chapter42'
 import XHTML59_CHAPTER43 from '@/components/xhtml/59_Chapter43'
 import XHTML60_CHAPTER44 from '@/components/xhtml/60_Chapter44'
 import XHTML61_CHAPTER45 from '@/components/xhtml/61_Chapter45'
 import XHTML62_CHAPTER46 from '@/components/xhtml/62_Chapter46'
 import XHTML63_CHAPTER47 from '@/components/xhtml/63_Chapter47'
 import XHTML64_PART8 from '@/components/xhtml/64_Part8'
 import XHTML65_CHAPTER48 from '@/components/xhtml/65_Chapter48'
 import XHTML66_CHAPTER49 from '@/components/xhtml/66_Chapter49'
 import XHTML67_CHAPTER50 from '@/components/xhtml/67_Chapter50'
 import XHTML68_CHAPTER51 from '@/components/xhtml/68_Chapter51'
 import XHTML69_PART9 from '@/components/xhtml/69_Part9'
 import XHTML70_CHAPTER52 from '@/components/xhtml/70_Chapter52'
 import XHTML71_CHAPTER53 from '@/components/xhtml/71_Chapter53'
 import XHTML72_CHAPTER54 from '@/components/xhtml/72_Chapter54'
 import XHTML73_CHAPTER55 from '@/components/xhtml/73_Chapter55'
 import XHTML74_CHAPTER56 from '@/components/xhtml/74_Chapter56'
 import XHTML75_CHAPTER57 from '@/components/xhtml/75_Chapter57'
 import XHTML76_CHAPTER58 from '@/components/xhtml/76_Chapter58'
 import XHTML77_CHAPTER59 from '@/components/xhtml/77_Chapter59'
 import XHTML78_CHAPTER60 from '@/components/xhtml/78_Chapter60'
 import XHTML79_CHAPTER61 from '@/components/xhtml/79_Chapter61'
 import XHTML80_AFTERWORD from '@/components/xhtml/80_Afterword'
 import XHTML81_APPENDIX01 from '@/components/xhtml/81_Appendix01'
 import XHTML82_APPENDIX02 from '@/components/xhtml/82_Appendix02'
 import XHTML83_APPENDIX03 from '@/components/xhtml/83_Appendix03'
 import XHTML84_APPENDIX04 from '@/components/xhtml/84_Appendix04'
 import XHTML85_NOTES from '@/components/xhtml/85_Notes'
 import XHTML86_BM01 from '@/components/xhtml/86_Bm01'
 import XHTML08_ACKNOWLEDGMENTS from '@/components/xhtml/08_Acknowledgments'
 import XHTMLLOVE2 from '@/components/xhtml/love2'
 import XHTMLAUTHOR from '@/components/xhtml/Author'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLORIMAD from '@/components/xhtml/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/EBB",
 			"name" : "xhtml/EBB",
 			"component" : XHTMLEBB
 		},
 		{
 			"path" : "/xhtml/love1",
 			"name" : "xhtml/love1",
 			"component" : XHTMLLOVE1
 		},
 		{
 			"path" : "/xhtml/01_Title",
 			"name" : "xhtml/01_Title",
 			"component" : XHTML01_TITLE
 		},
 		{
 			"path" : "/xhtml/02_Dadication",
 			"name" : "xhtml/02_Dadication",
 			"component" : XHTML02_DADICATION
 		},
 		{
 			"path" : "/xhtml/03_Fm01",
 			"name" : "xhtml/03_Fm01",
 			"component" : XHTML03_FM01
 		},
 		{
 			"path" : "/xhtml/04_Fm02",
 			"name" : "xhtml/04_Fm02",
 			"component" : XHTML04_FM02
 		},
 		{
 			"path" : "/xhtml/Toc",
 			"name" : "xhtml/Toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/06_Revised_edition",
 			"name" : "xhtml/06_Revised_edition",
 			"component" : XHTML06_REVISED_EDITION
 		},
 		{
 			"path" : "/xhtml/07_Preface",
 			"name" : "xhtml/07_Preface",
 			"component" : XHTML07_PREFACE
 		},
 		{
 			"path" : "/xhtml/09_Chronology",
 			"name" : "xhtml/09_Chronology",
 			"component" : XHTML09_CHRONOLOGY
 		},
 		{
 			"path" : "/xhtml/10_Part1",
 			"name" : "xhtml/10_Part1",
 			"component" : XHTML10_PART1
 		},
 		{
 			"path" : "/xhtml/11_Part2",
 			"name" : "xhtml/11_Part2",
 			"component" : XHTML11_PART2
 		},
 		{
 			"path" : "/xhtml/12_Chapter1",
 			"name" : "xhtml/12_Chapter1",
 			"component" : XHTML12_CHAPTER1
 		},
 		{
 			"path" : "/xhtml/13_Chapter2",
 			"name" : "xhtml/13_Chapter2",
 			"component" : XHTML13_CHAPTER2
 		},
 		{
 			"path" : "/xhtml/14_Chapter3",
 			"name" : "xhtml/14_Chapter3",
 			"component" : XHTML14_CHAPTER3
 		},
 		{
 			"path" : "/xhtml/15_Part3",
 			"name" : "xhtml/15_Part3",
 			"component" : XHTML15_PART3
 		},
 		{
 			"path" : "/xhtml/16_Chapter4",
 			"name" : "xhtml/16_Chapter4",
 			"component" : XHTML16_CHAPTER4
 		},
 		{
 			"path" : "/xhtml/17_Chapter5",
 			"name" : "xhtml/17_Chapter5",
 			"component" : XHTML17_CHAPTER5
 		},
 		{
 			"path" : "/xhtml/18_Chapter6",
 			"name" : "xhtml/18_Chapter6",
 			"component" : XHTML18_CHAPTER6
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js